module.exports = __webpack_public_path__ + "img/jsh_lct.c884adcb.png";